import type { SubscriptionType } from '../subscriptionStripe';

enum SubscriptionPlanType {
  FREE_TRIAL = 'FreeTrial',
  STARTER = 'Starter',
  PRO = 'Pro',
  ULTRA = 'Ultra',
  Custom = 'Custom',
}

export const getSubscriptionPlanLabel = (
  subscriptionPlanType?: SubscriptionPlanType | SubscriptionType | null,
) => {
  switch (subscriptionPlanType) {
    case SubscriptionPlanType.STARTER || 'Starter':
      return 'Lite';
    case SubscriptionPlanType.Custom || 'Custom':
      return 'Enterprise';
    default:
      return subscriptionPlanType;
  }
};

export default SubscriptionPlanType;
